const routes = {
  '/': 'Home',
  '/add-business': 'Add Business',
  '/forms': 'Forms',
  '/business-claims': 'Business Claims',
  '/dashboard': 'Dashboard',
  '/delete-requests': 'Delete Requests',
  '/geofences': 'Geofences',
  '/flags': 'Flags',
  '/categories': 'Business Categories',
  '/category-groups': 'Category Groups',
  '/users': 'Manage Users',
  '/copy-inventory': 'Copy Inventory',
  '/search-businesses': 'Search Businesses',
  '/admin-routes': 'Admin Routes',
  '/create-user': 'Create User',
  '/powered-pending': 'Powered Pending',
  '/publishers': 'Manage Publishers',
  '/components': 'Components',
  '/charts': 'Charts',
  '/components/buttons': 'Buttons',
  '/components/social-buttons': 'Social Buttons',
  '/components/cards': 'Cards',
  '/components/forms': 'Forms',
  '/components/modals': 'Modals',
  '/components/switches': 'Switches',
  '/components/tables': 'Tables',
  '/components/tabs': 'Tabs',
  '/icons': 'Icons',
  '/icons/font-awesome': 'Font Awesome',
  '/icons/simple-line-icons': 'Simple Line Icons',
  '/widgets': 'Widgets',
  '/partnership/create': 'Create Partner',
  '/partnership/view-partners': 'View Partners',
  'partners/:id': 'View Single Partner',
  'partners/:id/category-groups/create': 'Create Category Group',
  '/gonation-tv': 'GoNation TV',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js